import React, { useEffect, useState } from 'react';
import { motion } from 'framer-motion';
import { Shield, Lock, Zap, CreditCard, Star } from 'lucide-react';
import { trackInitiateCheckout } from '../lib/fpixel';
type Plan = 'profesional' | 'elite';
export function Pricing() {
  const [timeLeft, setTimeLeft] = useState({
    hours: 23,
    minutes: 59,
    seconds: 37
  });
  const [selected, setSelected] = useState<Plan>('elite');
  useEffect(() => {
    const timer = setInterval(() => {
      setTimeLeft(prev => {
        if (prev.seconds > 0) return {
          ...prev,
          seconds: prev.seconds - 1
        };
        if (prev.minutes > 0) return {
          ...prev,
          minutes: prev.minutes - 1,
          seconds: 59
        };
        if (prev.hours > 0) return {
          hours: prev.hours - 1,
          minutes: 59,
          seconds: 59
        };
        return prev;
      });
    }, 1000);
    return () => clearInterval(timer);
  }, []);
  const box = (value: number, label: string) => <div className="bg-white px-4 py-3 rounded-lg shadow-sm border border-gray-200 min-w-[72px]" data-id="element-194">
      <span className="text-3xl font-black text-gray-900" data-id="element-195">
        {String(value).padStart(2, '0')}
      </span>
      <span className="block text-xs text-gray-500 font-bold mt-1" data-id="element-196">
        {label}
      </span>
    </div>;
  const CHECKOUT_URLS: Record<Plan, string> = {
    profesional: 'https://profelisto.com.ar/checkouts/cn/hWNDjK4XCEfhCo0ooYcGPgYc/es-ar?_r=AQABVCpbo-v_gxX77S1SYsHQXQhnFLVzh_uPlgTKW1DraIM',
    elite: 'https://profelisto.com.ar/checkouts/cn/hWNDjK4n3Xm2KAeoP3EY2KPK/es-ar?_r=AQABDHAWRh689pGxKvth4HRrD0pKezH8ho736MzRcnbRv1s'
  };
  const ctaLabel = selected === 'elite' ? 'SÍ, QUIERO EL MEGAPACK ÉLITE →' : 'QUIERO EL PACK PROFESIONAL →';
  return <section id="precio" className="py-20 px-4 sm:px-6 lg:px-8 bg-f360-bg scroll-mt-4" data-id="element-197">
      <div className="max-w-content mx-auto" data-id="element-198">
        {/* Countdown header */}
        <div className="text-center mb-10" data-id="element-199">
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} data-id="element-200">
            <span className="inline-block py-1 px-3 rounded-full bg-red-600 text-white text-sm font-bold tracking-wide uppercase mb-6 shadow-sm animate-pulse" data-id="element-201">
              ⏰ PRECIO DE LANZAMIENTO — OFERTA POR TIEMPO LIMITADO
            </span>

            <div className="flex justify-center items-center gap-2 sm:gap-4 mb-4" data-id="element-202">
              {box(timeLeft.hours, 'HS')}
              <span className="text-2xl font-bold text-gray-400" data-id="element-203">:</span>
              {box(timeLeft.minutes, 'MIN')}
              <span className="text-2xl font-bold text-gray-400" data-id="element-204">:</span>
              {box(timeLeft.seconds, 'SEG')}
            </div>
            <p className="text-red-600 font-bold" data-id="element-205">
              🔴 El precio sube cuando termina el contador
            </p>
          </motion.div>
        </div>

        {/* Checkout card */}
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="bg-white rounded-3xl shadow-xl border border-gray-100 p-6 sm:p-10 max-w-2xl mx-auto" data-id="element-206">
          <div className="text-center mb-8" data-id="element-207">
            <h2 className="text-3xl sm:text-4xl font-extrabold text-gray-900 mb-3" data-id="element-208">
              Elegí tu Pack:
            </h2>
            <p className="text-lg text-gray-600 font-medium" data-id="element-209">
              Ambas opciones incluyen los 6 Bonus estratégicos
            </p>
          </div>

          {/* Pack Profesional option */}
          <button type="button" onClick={() => setSelected('profesional')} aria-pressed={selected === 'profesional'} className={`w-full text-left rounded-2xl border-2 p-5 sm:p-6 mb-5 transition-colors ${selected === 'profesional' ? 'border-f360-green bg-f360-green/5' : 'border-gray-200 hover:border-gray-300'}`} data-id="element-210">
            <div className="flex items-start gap-3 sm:gap-4" data-id="element-211">
              <span className={`flex-shrink-0 w-6 h-6 sm:w-7 sm:h-7 mt-1 rounded-full border-2 flex items-center justify-center ${selected === 'profesional' ? 'border-f360-green' : 'border-gray-300'}`} data-id="element-212">
                {selected === 'profesional' && <span className="w-3 h-3 sm:w-3.5 sm:h-3.5 rounded-full bg-f360-green" data-id="element-213" />}
              </span>
              <div className="flex-grow min-w-0" data-id="element-214">
                <div className="flex flex-col sm:flex-row sm:items-start sm:justify-between gap-2 sm:gap-4" data-id="element-215">
                  <div className="min-w-0" data-id="element-216">
                    <h3 className="text-lg sm:text-xl font-black text-gray-900 leading-tight" data-id="element-217">
                      📘 PACK PROFESIONAL
                    </h3>
                    <p className="text-sm text-gray-500 font-medium mt-1" data-id="element-218">
                      15 Tomos + 6 Bonus
                    </p>
                  </div>
                  <div className="flex items-baseline gap-2 sm:flex-col sm:items-end sm:gap-0 flex-shrink-0" data-id="element-219">
                    <span className="text-gray-400 line-through text-sm font-medium" data-id="element-220">
                      $29.990
                    </span>
                    <span className="text-2xl sm:text-3xl font-black text-gray-900 whitespace-nowrap" data-id="element-221">
                      $18.990
                    </span>
                  </div>
                </div>
              </div>
            </div>
          </button>

          {/* Megapack Élite option */}
          <button type="button" onClick={() => setSelected('elite')} aria-pressed={selected === 'elite'} className={`w-full text-left rounded-2xl border-2 p-5 sm:p-6 mb-8 transition-colors ${selected === 'elite' ? 'border-f360-gold bg-f360-gold/10' : 'border-gray-200 hover:border-gray-300'}`} data-id="element-222">
            <div className="flex items-start gap-3 sm:gap-4" data-id="element-223">
              <span className={`flex-shrink-0 w-6 h-6 sm:w-7 sm:h-7 mt-1 rounded-full border-2 flex items-center justify-center ${selected === 'elite' ? 'border-f360-gold' : 'border-gray-300'}`} data-id="element-224">
                {selected === 'elite' && <span className="w-3 h-3 sm:w-3.5 sm:h-3.5 rounded-full bg-f360-gold" data-id="element-225" />}
              </span>
              <div className="flex-grow min-w-0" data-id="element-226">
                <div className="flex flex-col sm:flex-row sm:items-start sm:justify-between gap-2 sm:gap-4" data-id="element-227">
                  <h3 className="text-lg sm:text-xl font-black text-gray-900 leading-tight min-w-0" data-id="element-228">
                    🏆 MEGAPACK ÉLITE
                  </h3>
                  <div className="flex items-baseline gap-2 sm:flex-col sm:items-end sm:gap-0 flex-shrink-0" data-id="element-229">
                    <span className="text-gray-400 line-through text-sm font-medium" data-id="element-230">
                      $49.990
                    </span>
                    <span className="text-2xl sm:text-3xl font-black text-f360-green whitespace-nowrap" data-id="element-231">
                      $27.990
                    </span>
                  </div>
                </div>
                <div className="flex flex-wrap gap-2 mt-3 mb-2" data-id="element-232">
                  <span className="inline-flex items-center gap-1 bg-f360-gold text-f360-dark text-xs font-black tracking-wide uppercase px-3 py-1 rounded-full" data-id="element-233">
                    <Star className="w-3 h-3 fill-current" data-id="element-234" /> MÁS ELEGIDO
                  </span>
                  <span className="inline-block bg-f360-gold/20 text-f360-dark text-xs font-black tracking-wide uppercase px-3 py-1 rounded-full" data-id="element-235">
                    AHORRÁS $11.000
                  </span>
                </div>
                <p className="text-sm text-gray-500 font-medium" data-id="element-236">
                  15 Tomos + 6 Bonus + 2 EBOOKS ÉLITE
                </p>
              </div>
            </div>
          </button>

          {/* Single dynamic CTA */}
          <a href={CHECKOUT_URLS[selected]} target="_blank" rel="noopener noreferrer" onClick={() => trackInitiateCheckout(selected === 'elite' ? 'Megapack Élite' : 'Pack Profesional')} className="block w-full text-center py-5 rounded-2xl font-black text-base sm:text-lg bg-f360-green text-white hover:bg-f360-dark transition-all shadow-lg hover:shadow-xl" data-id="element-237">
            {ctaLabel}
          </a>

          <p className="text-center text-sm text-gray-400 italic mt-5" data-id="element-238">
            La opción más elegida por profes de fútbol argentinos
          </p>
        </motion.div>

        {/* Trust badges */}
        <div className="mt-10 max-w-2xl mx-auto grid grid-cols-2 gap-4 text-sm text-gray-500 font-medium" data-id="element-239">
          <span className="flex items-center gap-2" data-id="element-240">
            <Lock className="w-4 h-4" data-id="element-241" /> Pago seguro
          </span>
          <span className="flex items-center gap-2" data-id="element-242">
            <Zap className="w-4 h-4" data-id="element-243" /> Acceso en 5 min
          </span>
          <span className="flex items-center gap-2" data-id="element-244">
            <Shield className="w-4 h-4" data-id="element-245" /> Garantía 7 días
          </span>
          <span className="flex items-center gap-2" data-id="element-246">
            <CreditCard className="w-4 h-4" data-id="element-247" /> Tarjeta · Transferencia
          </span>
        </div>
      </div>
    </section>;
}